const waypointImageSrc = 'https://cdn-assets.alltrails.com/assets/icons/maps/icon-waypoint@2x.png';
const waypointImageId = 'waypoint-icon';

const createWaypointMarkerLayer = (id, sourceId) => {
  return {
    id,
    type: 'symbol',
    source: sourceId,
    layout: {
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
      'icon-image': ['image', waypointImageId],
      'icon-size': 1,
      'text-field': ['get', 'order'],
      'text-font': ['Proxima Nova Bold'],
      'text-size': 14
    },
    paint: {
      'text-color': '#ffffff',
      'text-translate': [-0.5, -1]
    }
  };
};

export { createWaypointMarkerLayer, waypointImageSrc, waypointImageId };
